import Footer from "../components/footer";
import Header from "../components/header";
import SideNav from "../components/sidenav";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../components/pageHeader";
import { useNavigate } from "react-router-dom";
import debounce from 'lodash.debounce';

const ArtworkAll = () => {
    const navigate = useNavigate();
    const [artworkData, setArtworkData] = useState([]);
    const [artworkID, setArtworkID] = useState([]);
    const [artistID, setArtistID] = useState([]);
    const [statusID, setStatusID] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const [filterChoiceID, setFilterChoiceID] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [newdata, setNewdata] = useState({
        artworkID: 0, artistID: 0, statusID: 0, filterChoiceID: 0
    });

    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ArtworkList', setArtworkID);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindArtistList', setArtistID);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-StatusList', setStatusID);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ChoiceFilterList', setFilterChoiceID);
    }, []);

    const fetchDataFiltered = async () => {
        const { artworkID, artistID, statusID, filterChoiceID } = newdata;
        const url = `https://igapi.heuristticminds.com/api/ProductList/Get-GetArtworkListByFilter?artworkID=${artworkID}&artistID=${artistID}&statusID=${statusID}&filterChoiceID=${filterChoiceID}`;
        fetchData(url, setArtworkData);
    };

    useEffect(() => {
        fetchDataFiltered(); // Fetch filtered data when component mounts and when filter values change
    }, [newdata]);

    // Filter Data based on searchQuery
    useEffect(() => {
        const lowercasedFilter = searchQuery.toLowerCase();
        const filtered = artworkData.filter(item =>
            item.productTitle.toLowerCase().includes(lowercasedFilter) ||
            item.artistName.toLowerCase().includes(lowercasedFilter) ||
            item.artist_price.toString().toLowerCase().includes(lowercasedFilter) ||
            item.id.toString().toLowerCase().includes(lowercasedFilter)
        );
        setFilteredData(filtered);
    }, [searchQuery, artworkData]);



    const onChangeHandle = (e) => {
        const { name, value } = e.target;
        setNewdata(prevState => ({
            ...prevState,
            [name]: parseInt(value, 10)
        }));
    };

    // Debounced search handler to avoid excessive re-renders
    const handleSearchChange = debounce((e) => {
        setSearchQuery(e.target.value);
    }, 300);

    const columns = [
        {
            name: "ID",
            selector: row => row.id,
            sortable: true,
            width: "80px",
        },
        {
            name: "Uploaded On",
            selector: row => new Date(row.createdOn).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            sortable: true,
            width: "120px",
        },
        {
            name: "Owner/Artist",
            //selector: row => row.artistName,
            sortable: true,
            width: "150px",
            cell: row => (
                <div style={{ whiteSpace: "pre-wrap" }}>
                    {row.artistName}
                </div>
            ),
        },
        {
            name: "Artwork",
            cell: (row) => <img className="m-2" src={`../images/products/thumbnail/${row.image}`} alt=" " width="80px" />,
            width: "100px",
        },
        {
            name: "Artwork Title",
            selector: row => row.productTitle,
            sortable: true,
            width: "180px",
        },
        {
            name: "Price",
            selector: (row) => row.artist_price,
            sortable: true,
            width: "100px",
        },
        {
            name: "Status",
            cell: (row) => (
                <select
                    value={row.status} // Assuming `statusId` corresponds to the selected status
                    onChange={(e) => handleDataTableStatusChange(e, row.id, row.status)}
                    className="form-select"
                    disabled={row.is_lock === 2} // Disable if statusID = 4 or is_Lock = 2
                >
                    {statusID.map(uStatus => (
                        <option key={uStatus.id} value={uStatus.id}>{uStatus.statusType}</option>
                    ))}
                </select>
            ),
            width: "130px",
        },
        {
            name: "Action",
            cell: (row) => <>
                <button className="btn btn-light me-2 tp" onClick={(event) => onEditClick(event, row.id)}
                    disabled={row.status === 3 || row.status === 5 || row.is_lock === 2} // Disable if statusID = 4 or is_Lock = 2
                >
                    <span className="tptitle">Edit Product</span>
                    <i className="bi bi-pencil-square"></i>
                </button>
                {
                    (row.is_lock === 2) ?
                        <button className="btn btn-light me-2 tp text-danger" onClick={() => onIsLockClick(row.id, row.is_lock)}>
                            <span className="tptitle">Unlock Artwork</span>
                            <i className="bi bi-lock-fill"></i>
                        </button>
                        :
                        <button className="btn btn-light me-2 tp text-success" onClick={() => onIsLockClick(row.id, row.is_lock)}>
                            <span className="tptitle">Lock Artwork</span>
                            <i className="bi bi-unlock-fill"></i>
                        </button>
                }

                <button className="btn btn-light tp text-primary" onClick={(event) => onViewClick(event, row.id)}>
                    <span className="tptitle">View</span>
                    <i className="bi bi-eye-fill"></i>
                </button>
                <button className="btn btn-light tp text-primary" onClick={(event) => onUploadClick(event, row.id)}
                    disabled={row.status === 3 || row.status === 5 || row.is_lock === 2} // Disable if statusID = 4 or is_Lock = 2
                >
                    <span className="tptitle">Upload Artwork</span>
                    <i className="bi bi-upload"></i>
                </button>
            </>
        },
    ];

    const handleDataTableStatusChange = async (event, rowId, statusID) => {

        const newStatusId = event.target.value; // This gives you the new selected status ID
        const confirmed = window.confirm("Are you sure you want to change Artwork status?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {

            const response = await fetch(`https://igapi.heuristticminds.com/api/ProductList/Update-ChangeProductStatus?id=${rowId}&status=${newStatusId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {

                fetchDataFiltered();
            }
        }
        catch {
        }

    };

    const onUploadClick = (event, id) => {
        event.preventDefault(); // Prevents the default behavior of the link
        navigate(`/uploadArtwork/${id}`);
    };

    const onViewClick = (event, id) => {
        event.preventDefault();
        navigate(`/viewArtworkDetails/${id}`);
    };

    const onEditClick = (event, id) => {
        event.preventDefault();
        navigate(`/addArtwork/${id}`);
    };

    const onIsLockClick = async (id, isLock) => {
        const confirmed = window.confirm(`Are you sure you want to ${isLock === 2 ? 'Unlock' : 'Lock'} the Artwork?`);
        if (!confirmed) return;

        try {
            const url = `https://igapi.heuristticminds.com/api/ProductList/Update-ProductIsLockByID?id=${id}`;
            const response = await fetch(url, { method: 'PUT' });
            if (response.ok) {
                fetchDataFiltered();
            } else {
                console.log('Failed to update data');
            }
        } catch (error) {
            console.log('Error updating data', error);
        }
    };

    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='All Artwork' icon='bi bi-people-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">List Of Artwork</div>
                                        <div className="card-body">
                                            <div className="row mb-4">
                                                <div className="col-sm-12">
                                                    <a href="/addArtwork" className="btn btn-primary">
                                                        <i className="bi bi-plus-circle-fill"></i> Add Artwork
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col">
                                                    <select value={newdata.artworkID} onChange={onChangeHandle} name="artworkID" className="form-control form-select">
                                                        <option value={0}>--Select Artwork--</option>
                                                        {artworkID.map(aType => (
                                                            <option key={aType.id} value={aType.id}>{aType.artwork}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col">
                                                    <select value={newdata.artistID} onChange={onChangeHandle} name="artistID" className="form-control form-select">
                                                        <option value={0}>--Select Artist--</option>
                                                        {artistID.map(aName => (
                                                            <option key={aName.id} value={aName.id}>{aName.artist}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col">
                                                    <select value={newdata.statusID} onChange={onChangeHandle} name="statusID" className="form-control form-select">
                                                        <option value={0}>--Select Status--</option>
                                                        {statusID.map(uStatus => (
                                                            <option key={uStatus.id} value={uStatus.id}>{uStatus.statusType}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col">
                                                    <select value={newdata.filterChoiceID} onChange={onChangeHandle} name="filterChoiceID" className="form-control form-select">
                                                        <option value={0}>--Select Choice--</option>
                                                        {filterChoiceID.map(fChoice => (
                                                            <option key={fChoice.id} value={fChoice.id}>{fChoice.choiceFilter}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col">
                                                    <input type="text" name="search" onChange={handleSearchChange} className="form-control" placeholder="Text Search" />
                                                </div>

                                            </div>

                                            <DataTable columns={columns} data={filteredData} pagination />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default ArtworkAll;
